import api from './api';

export const customCategoriesService = {
    // Get all custom categories (Admin: support filtering; Reseller: own)
    getAll: async (params = {}) => {
        const response = await api.get('/custom-categories', { params });
        return response.data;
    },

    // Create custom category
    create: async (data) => {
        const response = await api.post('/custom-categories', data);
        return response.data;
    },

    // Delete custom category
    delete: async (id) => {
        const response = await api.delete(`/custom-categories/${id}`);
        return response.data;
    }
};

export default customCategoriesService;
